import { render, staticRenderFns } from "./BacAccordeon.vue?vue&type=template&id=227c3452&scoped=true&"
import script from "./BacAccordeon.vue?vue&type=script&lang=ts&"
export * from "./BacAccordeon.vue?vue&type=script&lang=ts&"
import style0 from "./BacAccordeon.vue?vue&type=style&index=0&id=227c3452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227c3452",
  null
  
)

export default component.exports